import { Injectable } from "@angular/core";
import {Observable} from "rxjs";

import {Process, ProcessList} from "app/models/cache_info.model";
import { DataProvider2 } from "../../provider/data2.provider";

@Injectable()
export class CacheInfoService {
	constructor(
		public dp: DataProvider2,
	) {
		
	}
	
	getList() : Observable<ProcessList<Process>> {
		return this.dp.get('/cache_info/stats');
	}
	
	killPid(pid : number, main : number) {
		return this.dp.get('/cache_info/stop', { pid, main });
	}

	stopAndPauseRebuilding() {
		return this.dp.get('/cache_info/pause');
	}

	resumeRebuilding() {
		return this.dp.get('/cache_info/resume');
	}
	
	startPid(flag: string) {
		return this.dp.get('/cache_info/start', { flag });
	}
}
